import { Language, OutletLanguageConfig } from './types';

const outletLanguageConfigs: Record<string, OutletLanguageConfig> = {
  IITV: {
    [Language.Farsi]: { shortCode: 'fa', locale: 'fa' },
    [Language.English]: { shortCode: 'en', locale: 'en' },
    [Language.Arabic]: { shortCode: 'ar', locale: 'ar-EG-u-nu-latn' },
  },
  AITV: {
    [Language.Farsi]: { shortCode: 'fa', locale: 'fa-AF' },
    [Language.English]: { shortCode: 'en', locale: 'en' },
    [Language.Pashto]: { shortCode: 'pa', locale: 'ps-pk-u-ca-persian' },
    [Language.Arabic]: { shortCode: 'ar', locale: 'ar-EG-u-nu-latn' },
  },
};

export const getLanguageConfigForOutlet = (outlet: string): OutletLanguageConfig => {
  const config = outletLanguageConfigs[outlet.toLocaleUpperCase()];
  if (!config) {
    throw new Error(`Unsupported outlet: ${outlet}`);
  }
  return config;
};